import request from '@/config/axios'

export const getScenicNoticePage = (params: any) => {
  return request.get({ url: '/scenic/notice/page', params })
}

export const getScenicNotice = (id: number) => {
  return request.get({ url: '/scenic/notice/get', params: { id } })
}

export const createScenicNotice = (data: any) => {
  return request.post({ url: '/scenic/notice/create', data })
}

export const updateScenicNotice = (data: any) => {
  return request.put({ url: '/scenic/notice/update', data })
}

export const updateScenicNoticeStatus = (id: number, status: number) => {
  return request.put({ url: '/scenic/notice/update-status', params: { id, status } })
}

export const deleteScenicNotice = (id: number) => {
  return request.delete({ url: '/scenic/notice/delete', params: { id } })
}
